import { Injectable } from '@angular/core';
import { getAccount, readContract, signTypedData } from '@wagmi/core'
import { wagmi_config } from '../core/wagmi/config';
import { AppkitService } from '../core/services/appkit.service';
import { SwProcessingService } from '../shared/services/sw-processing.service';
@Injectable({
  providedIn: 'root'
})
export class ContractCommonServiceService {

  constructor(private appkitService: AppkitService, private swProcessingService: SwProcessingService) { }

  /**
   * Customized read contract
   * @param contractParam 
   * @returns  
   */
  async customizedReadContract(contractParam: { abi: any, functionName: string, address: any, args: any[], chainId: any }) {
    return await readContract(this.appkitService.adapter.wagmiConfig , {
      address: contractParam.address,
      abi: contractParam.abi,
      functionName: contractParam.functionName,
      args: contractParam.args,
      chainId: contractParam.chainId,

    })
  }

  /**
   * Customized signature gen
   * @param contractdata 
   * @returns  
   */
  async customizedSignatureGen(contractdata: {
    domain: any,
    message: any,
    primaryType: any,
    types: any,
    account: any
  }) {
    // Marks the wallet signature as running so a new-build update never reloads the page
    // while the wallet prompt is open.
    this.swProcessingService.start();
    try {
      return await signTypedData(this.appkitService.adapter.wagmiConfig , {
        domain: contractdata.domain,
        message: contractdata.message,
        primaryType: contractdata.primaryType,
        types: contractdata.types,
        account: contractdata.account
      })
    } finally {
      this.swProcessingService.stop();
    }
  }
}
